<div class="container-wrapper">
  <mat-tab-group
    *ngIf="childItem.length"
    mat-stretch-tabs="false"
    mat-align-tabs="start"
    [(selectedIndex)]="selected"
    (selectedTabChange)="changeMenu($event)">
    <mat-tab *ngFor="let tabItem of childItem" [label]="tabItem.name"></mat-tab>
  </mat-tab-group>

  <div class="faq-section" *ngIf="activeSubCategory as subCat">
    <div class="accordian-wrapper" *ngIf="subCat.child.length > 0 && !shimmer">
      <ul aria-label="Subcategories">
        <li *ngFor="let item of subCat.child | paginate: { itemsPerPage: 10, currentPage: p }; index as i">
          <button type="button"
            class="faq-item-btn"
            [attr.id]="'kb-nested-subcategory-item-' + i"
            [attr.aria-label]="'Browse ' + item.name + ' subcategory'"
            (click)="goToSubCategoryChild(item.id, item.permalink)"
            (keydown)="onNestedSubCategoryKeydown($event, i)">
            <span class="label">{{ item.name }}</span>
            <span class="icon-right-chevron" aria-hidden="true"></span>
          </button>
        </li>
      </ul>
    </div>

    <div class="accordian-wrapper" *ngIf="subCat.child.length == 0 && !shimmer">
      <ul aria-label="Articles">
        <li *ngFor="let questionItem of questionsArray | paginate: { itemsPerPage: 10, currentPage: p }; index as i">
          <button type="button"
            class="faq-item-btn"
            [attr.id]="'kb-article-item-' + i"
            [attr.aria-label]="'Read article: ' + questionItem.title"
            (click)="goTosubCategoryAnswers(questionItem.id, questionItem.permalink, questionItem.categoryId)"
            (keydown)="onArticleKeydown($event, i)">
            <span class="label">{{ questionItem.title }}</span>
            <span class="icon-right-chevron" aria-hidden="true"></span>
          </button>
        </li>
      </ul>
    </div>

    <div class="accordian-wrapper" *ngIf="shimmer">
      <ul>
        <li>
          <span class="loading--shimmer w50"></span>
          <span class="icon-right-chevron"></span>
        </li>
        <li>
          <span class="loading--shimmer w50"></span>
          <span class="icon-right-chevron"></span>
        </li>
        <li>
          <span class="loading--shimmer w50"></span>
          <span class="icon-right-chevron"></span>
        </li>
        <li>
          <span class="loading--shimmer w50"></span>
          <span class="icon-right-chevron"></span>
        </li>
        <li>
          <span class="loading--shimmer w50"></span>
          <span class="icon-right-chevron"></span>
        </li>
      </ul>
    </div>

    <pagination-controls (pageChange)="p = $event" class="float-center"></pagination-controls>
  </div>
</div>
